<template>
  <div class="common-flexbox container">
    <div class="common-flexbox flex-direction-column">
      <div class="form-container">
      <div id="diclamerHeading" class="container-heading left-align">{{$t('disclaimer.heading')}}</div>
      <div class="common-flexbox disclaimer-content" v-html="disclaimerContent"></div>
      <div class="common-flexbox flex-content-center-align acceptDisclamerBtnContainer">
        <button id="acceptDisclamerBtn" class="common-button gutter-top-40" @click="accept()">{{$t('disclaimer.accept')}}</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';

import Constants from "@/utils/constants";

// Import available composables
import { usePresentation } from '@/composables/usePresentation';
import { useConferenceCall } from '@/composables/useConferenceCall';
import { useRouting } from '@/composables/useRouting';
import { useGlobal } from '@/composables/useGlobal';

// Define component name
defineOptions({
  name: 'disclaimer'
});

// Composables
const { t } = useI18n();

// Using composables for all functionality
const {
  disclaimers: disclaimersData,
  disclaimerContent,
  presentation,
  fetchDisclaimerContent,
  removeFirstDisclaimerFromStore,
} = usePresentation();

const {
  uniqueId,
  isSGMType,
  registerForConferenceCall,
} = useConferenceCall();

const { changeUrl } = useRouting();

const { displaySystemMessage } = useGlobal();

// Methods
const accept = async () => {
  removeFirstDisclaimerFromStore();
  if (disclaimersData.value.length > 0) {
    fetchDisclaimerContent();
  } else {
    if (!isSGMType.value) {
      await registerForConferenceCall();
    }
    if (uniqueId.value) {
      changeUrl('call-confirmation-new');
    } else {
      changeUrl('call-confirmation');
    }
  }
};

// Lifecycle hooks
onBeforeMount(() => {
  if (sessionStorage.getItem(Constants.SessionStorageKeys.AccountConfirmed)) {
    sessionStorage.removeItem(Constants.SessionStorageKeys.AccountConfirmed);
    displaySystemMessage(Constants.Messages.AccountConfirmation);
  }
});
</script>

<style lang="stylus">
@import '~@/shared/styles/common.scss';
@import '~@/shared/styles/HeroContent.scss';
@import '~@/shared/styles/formControl.scss';
.form-container {
  display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    min-height: 500px;
    flex-basis: auto;
}
  p
    line-height 1.4 !important;
    margin-bottom 10px !important;
    color #414141;

  .left-align
    align-self: flex-start !important;
    padding: 0 !important;

  .no-flex-grow
    flex: none;

  .container
    @media screen and (max-width: 768px) {
      display block;
    }
    
  .gutter-top-40
    margin-top 40px;

  .gutter-top-20
    margin-top 20px;
     
  .disclaimer-content
    text-align: left;
    overflow-y: auto;
    flex-flow: wrap;
    align-content: flex-start;
    width: 70%;
    flex-basis: auto !important;
    display: block !important;
    max-height: 380px;
    padding: 0 !important;
    * {
      all: revert;
    }
    @media screen and (max-width: 1280px) {
      max-height: 200px;
    }
    @media screen and (max-width: 768px) {
      width: 100% !important;
      height auto;
    }

    @media screen and (max-width: 1024px) {
      width: 82%;
    }

  .acceptDisclamerBtnContainer {
    height: auto;    
    align-items: flex-end;
    flex: 0.2;
    flex-basis: auto;
    justify-content: left !important;
    width: 70%
    @media screen and (max-width: 768px) {
      width: 100% !important;
    }
    @media screen and (max-width: 1024px) {
      width: 82%;
    }

    #acceptDisclamerBtn {
      background: var(--primary-color);
      width: 100%;
      @media screen and (max-width: 768px) {
        margin-right: 0;
        width: 100%;
      }

      @media screen and (max-width: 1024px) {
        margin-right: 0;
        width: 100%;
      }
    }
  }
  
    
</style>